<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M3.33317 7.99967H12.6665M12.6665 7.99967L7.99984 12.6663M12.6665 7.99967L7.99984 3.33301"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
        />
    </svg>
</template>
